import getMetaElements from "shared/components/MetaTags/getMetaElements"
import getMetaTagsString from "shared/components/MetaTags/getMetaTagsString"
import { buildAppTester } from "supporting"
import { getMetaDescription } from "shared/components/AlteredHelmet/useMetaDescription"
import { getSmallestImage } from "shared/helpers/ssr"
/**
 * функция отвечает за формирование шаблона в блоке head разметки
 */
export const getHeadTemplate = ({props, activeRoute, objProps }: any) => {
    const { competitionRu, notFound, definedApp } = props
    const { req } = objProps
    if (!competitionRu) return;
    const appTester = buildAppTester(() => definedApp.application)
    const pathname = req.url.split('?')[0];
    const { description } = getMetaDescription(appTester, pathname)
    const smallestImage = getSmallestImage(competitionRu.titleImages);
    const ogImage = smallestImage ? smallestImage.url : '';
    const title = competitionRu.title;

    const imageUrl = `https://files.mediiia.ru/${ogImage}`

    const elements = getMetaElements({title, imageUrl, description: [description]})

    const metaTags = getMetaTagsString(elements)

    return `
        <title>${title}</title>
        ${metaTags}
    `
}import getMetaElements from "shared/components/MetaTags/getMetaElements"
import getMetaTagsString from "shared/components/MetaTags/getMetaTagsString"
import { buildAppTester } from "supporting"
import { getMetaDescription } from "shared/components/AlteredHelmet/useMetaDescription"
import { getSmallestImage } from "shared/helpers/ssr"
/**
 * функция отвечает за формирование шаблона в блоке head разметки
 */
export const getHeadTemplate = ({props, activeRoute, objProps }: any) => {
    const { competitionRu, notFound, definedApp } = props
    const { req } = objProps
    if (!competitionRu) return;
    const appTester = buildAppTester(() => definedApp.application)
    const pathname = req.url.split('?')[0];
    const { description } = getMetaDescription(appTester, pathname)
    const smallestImage = getSmallestImage(competitionRu.titleImages);
    const ogImage = smallestImage ? smallestImage.url : '';
    const title = competitionRu.title;

    const imageUrl = `https://files.mediiia.ru/${ogImage}`

    const elements = getMetaElements({title, imageUrl, description: [description]})

    const metaTags = getMetaTagsString(elements)

    return `
        <title>${title}</title>
        ${metaTags}
    `
}